import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-user-list',
    templateUrl: './user-list.component.html',
    styleUrl: './user-list.component.css',
    standalone: false
})
export class UserListComponent implements OnInit{
  public breadcrumb: any;
  options = {
    close: false,
    expand: false,
    minimize: false,
    reload: false
  };
  model: any = {};
  rows:any;


  ngOnInit(): void {
    this.breadcrumb = {
      'mainlabel': 'User Management',
     
    };

    // this.getCategories();
  }
}
